export const actions = {
    FETCH_LISTING_WRAPPER_LIST: "FETCH_LISTING_WRAPPER_LIST",
    SUCCESSFUL_FETCH_LISTING_WRAPPER_LIST: "SUCCESSFUL_FETCH_LISTING_WRAPPER_LIST",
    FETCH_RESOURCE_WRAPPER_LIST: "FETCH_RESOURCE_WRAPPER_LIST",
    SUCCESSFUL_FETCH_RESOURCE_WRAPPER_LIST: "SUCCESSFUL_FETCH_RESOURCE_WRAPPER_LIST",
};

export const initialState = {
    list: [],
};

export default (state = initialState, { type, response, resourceId }) => {
    switch (type) {
        case actions.SUCCESSFUL_FETCH_LISTING_WRAPPER_LIST: {
            return {
                ...state,
                list: response?.data?.wrapper_plain_list,
            };
        }

        case actions.SUCCESSFUL_FETCH_RESOURCE_WRAPPER_LIST: {
            return {
                ...state,
                [`${resourceId}_resource_wrapper_list`]:
                    response?.data?.resource_wrapper_plain_list,
            };
        }
        default:
            return state;
    }
};
